import pinInput from "./pinInput.svg";
import pinInputActive from "./pinInputActive.svg";
export default { pinInput, pinInputActive };
